import React, { useState, useEffect } from "react";
import "./style.less";
import useWindowDimensions from "../../useWindowDimensions";

import redBackArrow from "../../images/homepage/redBackArrow.svg";
import redNextArrow from "../../images/homepage/redNextArrow.svg";
import blackBackArr from "../../images/about/blackBackArr.svg";
import blackNextArr from "../../images/about/blackNextArr.svg";
import Imageurldata from "../../Imageurldata";
import Swiper, { Navigation, Pagination, Autoplay, Thumbs } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, Thumbs]);

const OurTeamSlide = (props) => {
  const { height, width } = useWindowDimensions();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    var PersonDetailsSwiper = new Swiper(".aboutsec4 .PersonDetailsSwiper", {
      spaceBetween: 10,
      centeredSlides: false,
      slidesPerView: 5,
      slideToClickedSlide: true,
      loop: true,
      allowTouchMove: true,
      navigation: {
        prevEl: ".arrow-btn.left",
        nextEl: ".arrow-btn.right",
      },

      // freeMode: true,
      // watchSlidesVisibility: true,
      // watchSlidesProgress: true,
    });

    var mPersonDetailsSwiper = new Swiper(".aboutsec4 .mPersonDetailsSwiper", {
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: false,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: ".aboutsec4 .rightarrow",
        prevEl: ".aboutsec4 .leftarrow",
      },
    });

    PersonDetailsSwiper.on("transitionEnd", function () {
      //console.log("*** mySwiper.realIndex", PersonDetailsSwiper.realIndex);
      setIndex(PersonDetailsSwiper.realIndex);
    });

    mPersonDetailsSwiper.on("transitionEnd", function () {
      //console.log("*** mySwiper.realIndex", mPersonDetailsSwiper.realIndex);
      setIndex(mPersonDetailsSwiper.realIndex);
      mPersonDetailsSwiper.updateAutoHeight();
    });

    // var PersonDescSwiper = new Swiper(".aboutsec4 .PersonDescSwiper", {
    //   centeredSlides: true,
    //   spaceBetween: 10,
    //   slidesPerView: 1,
    //   loop: true,
    //   slideToClickedSlide: true,
    //   thumbs: {
    //     swiper: PersonDetailsSwiper,
    //   },
    // });
  }, []);

  const PersonDetailsSlider = props.aboutsection4.map((item, i = 1) => (
    <div key={i} className="swiper-slide">
      <div className="personImg">
        <img className="img-fluid c-p" src={item.img} />
      </div>
      <div className="personName">{item.name}</div>
      <div className="personDesg">{item.designation}</div>
      {/* {index == i && (
        <div className="PersonDesc">
          <p>{props.aboutsection4[index].desc}</p>
        </div>
      )} */}
    </div>
  ));

  const PersonDescSlider = props.aboutsection4.map((item, i = 1) => (
    <div key={i} className="swiper-slide">
      <div className="PersonDesc">
        <p>{item.desc}</p>
      </div>
    </div>
  ));

  const mPersonDetailsSlider = props.aboutsection4.map((item, i = 1) => (
    <div key={i} className="swiper-slide">
      <div className="personImg">
        {/* <img className="img-fluid c-p" src={props.image_url + item.img} /> */}
        <img className="img-fluid c-p" src={item.img} />
      </div>
      <div className="personName">{item.name}</div>
      <div className="personDesg">{item.designation}</div>
      <div className="PersonDesc">
        {/* <p>{props.aboutsection4[index].desc}</p> */}
        <p>{item.desc}</p>
      </div>
    </div>
  ));
  return (
    <>
      <div className="ourTeamSlider">
        {width >= 1024 ? (
          <>
            <button className="arrow-btn left">
              <img src={redBackArrow} />
            </button>
            <div className="PersonDetailsSwiper swiper-container">
              <div className="swiper-wrapper">{PersonDetailsSlider}</div>
            </div>

            <div className="PersonDesc">
              <p>{props.aboutsection4[index].desc}</p>
            </div>

            <button className="arrow-btn right">
              <img src={redNextArrow} />
            </button>
          </>
        ) : (
          <>
            <div className="mPersonDetailsSwiper swiper-container">
              <div className="swiper-wrapper">{mPersonDetailsSlider}</div>
              <div className="d-f j-c a-c">
                <div className="arrow d-f as-c">
                  <div className="leftarrow">
                    <img src={redBackArrow} className="fluid c-p"></img>
                  </div>
                  <div className="rightarrow">
                    <img src={redNextArrow} className="fluid c-p"></img>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default OurTeamSlide;
